import * as React from 'react';
import cx from 'classnames';

import './Flex.styles.scss';

export class Flex extends React.Component {
	render() {
		const { children, wrap, width = 'auto', justify, alignItems, className, inline, reference, direction, ...otherProps } = this.props;

		return (
			<div 
				ref={reference}
				style={{ width }} 
				className={cx(
					'Flex', 
					`Flex-${wrap}`, 
					{ 'Flex-inline': inline, }, 
					`Flex-justify-${justify}`, 
					`Flex-alignItems-${alignItems}`, 
					`Flex-direction-${direction}`,
					className
				)} 
				{...otherProps}
			>
				{children}
			</div>
		);
	}
}